import { useQueryUser } from '@heidi/workspace/data';
import { useCallback } from 'react';
import { useUpdateEvidenceSettings } from '../../data/injected';

/**
 * EVI-1698: DB-backed acceptance for the library document-upload risk opt-in
 * (EVI-1566). Replaces the prior localStorage-only flag so acceptance follows
 * the user across devices and provides an auditable timestamp.
 */
export const useLibraryUploadRiskAcceptance = () => {
  const { data: userData, isPending } = useQueryUser((data) => ({
    libraryUploadRiskAcceptedAt:
      data?.evidence_settings?.library_upload_risk_accepted_at ?? null,
  }));
  const updateUser = useUpdateEvidenceSettings();

  const hasAccepted = Boolean(userData?.libraryUploadRiskAcceptedAt);

  const accept = useCallback(() => {
    updateUser({
      evidence_settings: {
        library_upload_risk_accepted_at: new Date().toISOString(),
      },
    });
  }, [updateUser]);

  return { hasAccepted, accept, isPending };
};
